import Helpers from "../../commons/helpers";
import IdentityClient from "./IdentityClient";
import { Status } from "../../constants/enums";
import { Constants } from "../../constants/constants";
import { IInvitation, IPagedList } from "./../../commons/interfaces";
import { HttpClient } from "../base/HttpClient";



interface IRequestQuickInvite {
    clientId: string;
    emails: string[];
    organizationIds: string[];
}

export interface IRequestGetAllInvitation {
    organizationId?: string;

    type?: number;
    email?: string;
    status?: Status;
    groupIds?: string[];
    roleCodes?: string[];
    resourceCodes?: string[];
}

export interface IRequestGetPagedInvitation {
    tenantCode?: string;
    serviceCode?: string;
    organizationId?: string;

    type?: number;
    email?: string;
    emails?: string[];
    roleCodes?: string[];
    resourceCodes?: string[];

    validTo?: string;
    validFrom?: string;

    status?: Status;
    searchText?: string;
    isIndividual?: boolean;

    orderBy?: string;
    pageSize?: number;
    pageNumber?: number;
    totalCount?: number;
}

export interface ICreateInvitation {
    clientId: string,
    tenantCode: string,
    organizationId: string,

    emails: string[],
    roles?: string[],
    groupIds?: string[],
    communities?: ICommunitiesByInvitation[],
    userResources?: IUserResourcesByInvitation[],
    note?: string,
}

export interface IUserResourcesByInvitation {
    resourceCode?: string,
    permissions?: number[],
    startTime?: string | number,
    endTime?: string | number,
}

export interface ICommunitiesByInvitation {
    roleType?: number,
    resourceCode?: string,
    channelIds?: string[],
}

const InvitationService = {
    async getAll(data?: any): Promise<IInvitation[]> {
        const query = data ? "" : `?${Helpers.handleFormatParams(data)}`;
        const result = await IdentityClient().get(
            `${Constants.ApiPath.INVITATION.GET_ALL}${query}`
        );
        return result.data.result;
    },

    async getPaged(data: IRequestGetAllInvitation): Promise<IPagedList<IInvitation>> {
        const query = Helpers.handleFormatParams(data);
        const result = await IdentityClient().get(
            `${Constants.ApiPath.INVITATION.GET_PAGED}?${query}`
        );
        return result.data.result;
    },

    async getPagedTenant(data: any): Promise<IPagedList<IInvitation>> {
        const query = Helpers.handleFormatParams(data);
        const result = await IdentityClient().get(
            `${Constants.ApiPath.INVITATION.GET_PAGED_TENANT}?${query}`
        );
        return result.data.result;
    },

    async getDetail(id: string): Promise<IInvitation> {
        const result = await IdentityClient().get(
            `${Constants.ApiPath.INVITATION.GET_DETAIL}/${id}`
        );
        return result.data.result;
    },

    async create({ data, newDomain }: { data: ICreateInvitation, newDomain?: string }) {
        const result = await IdentityClient(newDomain).post(Constants.ApiPath.INVITATION.CREATE, data);
        return result.data;
    },

    async resend(id: string) {
        const result = await IdentityClient().post(
            `${Constants.ApiPath.INVITATION.RESEND}/${id}`
        );
        return result.data;
    },

    async delete(id: string) {
        const result = await IdentityClient().post(
            `${Constants.ApiPath.INVITATION.DELETE}/${id}`
        );
        return result.data;
    },

    async accept(id: string) {
        const result = await IdentityClient().post(
            `${Constants.ApiPath.INVITATION.ACCEPT}/${id}`
        );
        return result.data;
    },

    async decline(id: string) {
        const result = await IdentityClient().post(
            `${Constants.ApiPath.INVITATION.DECLINE}/${id}`
        );
        return result.data;
    },

    async quickInvite(data: IRequestQuickInvite) {
        const result = await IdentityClient().post(
            Constants.ApiPath.INVITATION.QUICK_INVITE,
            data
        );
        return result.data.result;
    },
};

export default InvitationService;
